import { useIsMobile } from "@/hooks/use-mobile";

// Desktop no longer has a top header (the navy rail sits beside <main>, not
// above it): the only vertical offset left is <Layout>'s own p-4 (top+bottom).
const DESKTOP_MAIN_PADDING = 32;
const DENSE_NAVBAR_HEIGHT_MOBILE = 64;

export default function useAppBarHeight(): number {
  const isMobile = useIsMobile();
  return isMobile ? DENSE_NAVBAR_HEIGHT_MOBILE : DESKTOP_MAIN_PADDING;
}
